import { render, staticRenderFns } from "./DocumentPropertyList.vue?vue&type=template&id=09be8855&scoped=true&"
import script from "./DocumentPropertyList.vue?vue&type=script&lang=js&"
export * from "./DocumentPropertyList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPropertyList.vue?vue&type=style&index=0&id=09be8855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be8855",
  null
  
)

export default component.exports